import * as DKFDS from 'dkfds';
import $ from 'jquery';

$('.file-input input[type="file"]').on('rov:fileselect', function () {
    if (window.FileList && this.files[0].size > (15*1024*1024)) {
        const $modal = $("#fileModal");
        new DKFDS.Modal($modal.get(0)).show();
    } else {
        document.getElementById('mainForm').submit();
    }
});

$("#fileModal").get(0).addEventListener('fds.modal.hidden', function () {
    document.getElementById('mainForm').reset();
});
